const production = "https://api.rentrips.id";
const development = "http://localhost:8080";
export const RentripsURL =
	process.env.NODE_ENV === "development" ? development : production;
